import store from './actions/store';
import { LOGOUT, LOGIN } from './actions/types';
import { setHiddenItemsId } from "./actions/sidebarActions";

class Auth {
  constructor() {
    this.authenticated = false;
  }

  isAuthenticated = () => store.getState().general.isAuthenticated || false;

  login(idSeller, userName, tipoUsuario, userId, hiddenItemsIds) {
    store.dispatch({
      type: LOGIN,
      payload: {
        idSeller,
        userName,
        tipoUsuario,
        userId
      }
    });

    store.dispatch(setHiddenItemsId(hiddenItemsIds));
  }

  logout() {
    store.dispatch({
      type: LOGOUT,
      payload: false,
    });
  }
}

export default new Auth();